import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconToolkit = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0 0h1024v1024H0z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 70.36490400000001,
		d: "m482.988 659.18 269.886 269.887c22.869 22.174 53.515 34.58 85.41 34.58 67.31 0 122.768-55.458 122.768-122.768 0-31.896-12.406-62.541-34.58-85.41L654.41 483.407M482.988 659.18l115.546-140.267c14.675-17.776 34.257-28.979 55.922-35.46M482.988 659.18 267.495 920.873a117.96 117.96 0 0 1-91.196 43.145c-64.718 0-117.954-53.237-117.954-117.954a117.96 117.96 0 0 1 43.145-91.197L417.993 494.24m236.463-10.786c25.46-7.592 53.838-8.703 80.688-6.48 5.926.508 11.851.74 17.823.74 114.296 0 208.317-94.02 208.317-208.317a208.3 208.3 0 0 0-18.47-85.734l-151.656 151.7C739.496 323.42 698.943 282.868 687 231.205L838.655 79.55a208.3 208.3 0 0 0-85.735-18.47c-114.296 0-208.317 94.02-208.317 208.317 0 5.971.232 11.897.741 17.822 4.213 49.811-3.287 104.807-41.849 136.564l-4.721 3.935m-80.781 66.522L227.869 304.115h-65.227L58.484 130.518l69.439-69.44 173.597 104.16v65.225L498.727 427.67m-80.78 66.523 80.78-66.523"
	})]
});
export default SvgIconToolkit;
